export class ClaraStreamHttpError extends Error {
  constructor(public readonly status: number) {
    super(`Clara stream request failed with status ${status}`);
    this.name = "ClaraStreamHttpError";
  }
}
